import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    title: {
      type: String
    },
    operateId: {
      type: Number
    },
    dataShowList: {
      type: Array
    },
    pageSize: {
      type: Number
    },
    filterable: {
      type: Boolean
    },
    filterPlaceholder: {
      type: String
    },
    pageTexts: {
      type: Array
    },
    async: {
      type: Boolean,
      default: function _default() {
        return false;
      } // 已选区不做异步

    },
    isLastPage: {
      type: Boolean
    },
    isHighlight: {
      type: Boolean
    },
    asyncSearchFlag: {
      // 是否设置了异步搜索方法
      type: Boolean
    },
    showClearBtn: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      districtListMock: [],
      // 展示的数据 （搜索和分页会自动修改这个数组）
      checkedData: [],
      // 已选择，数据格式：[id,id,id...]
      isIndeterminate: false,
      checkAll: false,
      searchWord: '',
      len: 0,
      total: 0,
      pageIndex: 0,
      disabledPre: true,
      disabledNex: false,
      asyncSearch: false,
      // 要执行异步搜索的标记
      asyncPageIndex: 1,
      // 异步分页的 pageIndex
      asyncSearchPageIndex: 1 // 异步搜索的 pageIndex

    };
  },
  created: function created() {
    this.initData();
  },
  watch: {
    // 搜索框的监听器
    searchWord: function searchWord(newWord) {
      this.$emit('search-word', newWord, this.operateId);
    },
    // districtListMock 和 checkAll 的监听器
    districtListMock: function districtListMock() {
      // 当方框中无已选择的数据时，不能勾选checkBox
      if (this.checkedData.length === 0) {
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    checkedData: function checkedData(newWord) {
      this.$emit('check-disable', newWord, this.operateId);
    },
    // 当列表中无数据时，不能勾选checkBox
    checkAll: function checkAll() {
      this.checkAll = this.districtListMock.length === 0 ? false : this.checkAll;
    },
    dataShowList: {
      handler: function handler() {
        this.async ? this.asyncInitData() : this.initData();
      },
      deep: true
    }
  },
  methods: {
    handleKeyword: function handleKeyword() {
      this.asyncSearchPageIndex = 1;
      this.asyncSearchFlag && this.$emit('get-data-by-keyword', this.searchWord, this.asyncSearchPageIndex);
    },
    // 分页数据
    initData: function initData() {
      this.len = this.dataShowList.length;
      this.total = Math.ceil(this.len / this.pageSize);
      this.pageIndex = 0;
      this.pageData();
    },
    pageData: function pageData() {
      this.checkedData = [];

      if (this.total > 1 && this.pageIndex < this.total - 1) {
        this.pageIndex === 0 ? this.disabledPre = true : this.disabledPre = false;
        this.disabledNex = false;
        this.districtListMock = this.dataShowList.slice(this.pageIndex * this.pageSize, this.pageIndex * this.pageSize + this.pageSize);
      } else {
        this.total > 1 ? this.disabledPre = false : this.disabledPre = true;
        this.disabledNex = true;
        this.districtListMock = this.dataShowList.slice(this.pageIndex * this.pageSize, this.len);
      }
    },
    // 异步获取的数据，检查分页按钮可用性
    asyncInitData: function asyncInitData() {
      // 取消勾选
      this.checkedData = []; // 分页按钮可用性

      this.disabledNex = this.isLastPage;
      this.disabledPre = this.asyncSearchFlag && this.asyncSearch ? this.asyncSearchPageIndex <= 1 : this.asyncPageIndex <= 1; // 赋值

      this.districtListMock = this.dataShowList;
    },
    // 上一页
    prev: function prev() {
      if (this.async) {
        // 异步获取数据
        this.disabledPre = true;
        this.asyncSearchFlag && this.asyncSearch ? this.$emit('get-data-by-keyword', this.searchWord, this.asyncSearchPageIndex <= 1 ? 1 : --this.asyncSearchPageIndex) : this.$emit('get-data', this.asyncPageIndex <= 1 ? 1 : --this.asyncPageIndex);
      } else {
        this.pageIndex > 0 && --this.pageIndex;
        this.pageData();
      }
    },
    // 下一页
    next: function next() {
      if (this.async) {
        // 异步获取数据
        this.disabledNex = true;
        this.asyncSearchFlag && this.asyncSearch ? this.$emit('get-data-by-keyword', this.searchWord, ++this.asyncSearchPageIndex) : this.$emit('get-data', ++this.asyncPageIndex);
      } else {
        this.pageIndex <= this.total - 1 && ++this.pageIndex;
        this.pageData();
      }
    },
    // 单选
    handleCheckedChange: function handleCheckedChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.districtListMock.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.districtListMock.length; // 子传父

      this.$emit('check-district', value);
    },
    // 全选
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedData = val ? this.districtListMock.map(function (val) {
        return val;
      }) : [];
      this.isIndeterminate = false; // 子传父

      this.$emit('check-district', this.checkedData);
    },
    clearInp: function clearInp() {
      this.$emit('clear-input');
    },
    filterHighlight: function filterHighlight(label) {
      var filterWord = this.searchWord.trim();
      label = label && label.trim();

      if (filterWord && label) {
        var reg = new RegExp(filterWord);
        return label.replace(reg, "<span class=\"red\">".concat(filterWord, "</span>"));
      } else {
        return label;
      }
    }
  },
  components: {}
};